export const calcFont = (text: string, multipler = 1) => {
  const words = text.split(' ');
  const wordCount = words.length;

  const baseFontSize = 6.5;
  const fontSizeDecrement = 0.35 * multipler;

  if (wordCount > 7) {
    const fontSize =
      baseFontSize - Math.floor(wordCount / 5) * fontSizeDecrement;
    return `${Math.max(fontSize, 0.5)}vw`;
  }

  return baseFontSize + 'vw';
};
